<div class="bloco" [formGroup]="comissao">
  <div class="row">
    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Base comissão</mat-label>
        <input matInput [value]="base | abnt: 'preco' : 2" disabled class="campo-numero">
        <mat-hint>Valor do item menos o desconto do documento.</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Alíq. comissão (%)</mat-label>
        <input matInput formControlName="percentualComissao" [currencyMask]="mascaraPercentual" class="campo-numero">
      </mat-form-field>
    </div>

    <div class="col-6 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Valor comissão</mat-label>
        <input matInput [value]="valor | abnt: 'preco' : 2" disabled class="campo-numero">
      </mat-form-field>
    </div>
  </div>
</div>
